import * as z from 'zod';
import { dayjs } from '@/dayjs';
/**
 * Taggar är till för att snabbt identifiera datatyper.
 */
export const Tag = (tag) => z.literal(tag)
    .default(tag)
    .catch(tag)
    .readonly();
export const EntityId = z.int().positive();
export const Ören = z.int().min(0);
export const Quantity = z.int().min(0);
const LocalizedStringResponse = z.object({
    sv: z.string().nullable(),
    en: z.string().nullable(),
    de: z.string().nullable()
});
const NormalizedLocalizedString = z.object({
    sv: z.string(),
    en: z.string().nullable(),
    de: z.string().nullable()
});
export const LocalizedString = z.codec(LocalizedStringResponse, NormalizedLocalizedString, {
    decode: localizedString => ({
        ...localizedString,
        sv: localizedString.sv ?? ''
    }),
    encode: localizedString => localizedString
});
export const DayJsSchema = z.custom(val => dayjs.isDayjs(val));
export const DurationSchema = z.custom(val => dayjs.isDuration(val));
